const bankPark = {
	yellow: "#fbcb03",
	green: "#03fb3a",
	primary: "#231f20",
	primaryHover: "#3c3c3c",
	primaryDark: "#000",
	secondary: "#ffe021",
	secondaryHover: "#e7c90d",
	secondaryDark: "#8a7701",
	light: "#f6f6f6",
	lightGray: "#e2e2e2",
	gray: "#c5c5c5",
	darkGray: "#595858",
	lightDark: "#666666",
	dark: "#3b3b3b",
	white: "#fff",
	danger: "#eb092f",
};

export default {
	"bank-park": bankPark,
};
